import { gql } from "urql";
export const GetPriorityNotesQuery = gql `
    query GetPriorityNotes(
        $caregiverId: String!
        $patientId: String!
        $search: String
    ) {
        priorityNotes {
            priorityNotes(
                caregiverId: $caregiverId
                patientId: $patientId
                search: $search
            ) {
                priorityNoteId
                priorityEntryId
                organizationId
                note
                noteType
                contactType
                contactReason
                contactOutcome
                name
                imageUrl
                createdAt
            }
        }
    }
`;
